import { createSelector } from '@ngrx/store';
import { addressProviderState } from '../root';

export const getAddressProviderReverseGeocodeResults = createSelector(addressProviderState, (addressProvider) =>
    addressProvider?.geocoder?.reduce((places, place) => {
        if (place.data?.length) {
            places.push(...place.data);
        }

        return places;
    }, [] as OLO.DTO.AddressSugestionDto[]),
);
